"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Week_1 = __importDefault(require("../Week/Week"));
var react_1 = require("react");
var Weeks = /** @class */ (function (_super) {
    __extends(Weeks, _super);
    function Weeks() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Weeks.prototype.render = function () {
        var _a = this.props, disabled = _a.disabled, month = _a.month, selected = _a.selected, select = _a.select, from = _a.from, to = _a.to;
        var weeks = [];
        var done = false;
        var count = 0;
        var date = month.clone();
        var monthIndex = date.month();
        date = date.clone().startOf('week');
        while (!done) {
            weeks.push(React.createElement(Week_1.default, { key: count, index: count, date: date.clone(), month: month, select: select, selected: selected, disabled: disabled, from: from, to: to }));
            date.add(1, 'w');
            done = count++ > 2 && monthIndex !== date.month();
            monthIndex = date.month();
        }
        return weeks;
    };
    return Weeks;
}(react_1.Component));
exports.default = Weeks;
